import moment from 'moment';

export default {
  methods: {
    now() {
      return moment(new Date()).format();
    },
    formatDate(date, format = 'YYYY-MM-DD') {
      return moment(date)
        .format(format);
    },
    subtractIn(date, qtd, type) {
      return moment(date).subtract(qtd, type);
    },
    addDateIn(date, qtd, type) {
      return moment(date).add(qtd, type);
    },
    isEqualDate(date, compare = this.now()) {
      return moment(
        (compare || this.now()),
      ).format() === moment(date).format();
    },
    isAfterDate(date, compare = this.now()) {
      return moment(
        date,
      ).isAfter(
        (compare || this.now()),
      );
    },
    isBeforeDate(date, compare = this.now()) {
      return moment(
        date,
      ).isBefore(
        (compare || this.now()),
      );
    },
  },
  computed: {
    date() {
      return moment;
    },
  },
};
